<div id="title--container">
  <h4>Fluorescence Channels</h4>
  <h5>{{ laboratory()?.laboratoryName }}</h5>
</div>
<hr />
<div id="inner-page--container">
  <div id="toggle--container">
    <app-underlined-option-tab-toggle
      radioGroup="navigationToggle"
      [selectOptions]="navOptions"
    >
    </app-underlined-option-tab-toggle>
  </div>
  <hr />
  @if (fluorescenceChannelsLoading()) {
    <div id="loading--container">
      <app-loading-spinner></app-loading-spinner>
    </div>
  } @else {
    <div id="table--container">
      <table mat-table [dataSource]="fluorescenceChannels()">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let channel">{{ channel.channelName }}</td>
        </ng-container>

        <ng-container matColumnDef="lowerBand">
          <th mat-header-cell *matHeaderCellDef>Lower Band (nm)</th>
          <td mat-cell *matCellDef="let channel">{{ channel.lowerBand }}</td>
        </ng-container>

        <ng-container matColumnDef="upperBand">
          <th mat-header-cell *matHeaderCellDef>Upper Band (nm)</th>
          <td mat-cell *matCellDef="let channel">{{ channel.upperBand }}</td>
        </ng-container>

        <ng-container matColumnDef="led">
          <th mat-header-cell *matHeaderCellDef>Excitation LED</th>
          <td mat-cell *matCellDef="let channel">{{ channel.led }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length" id="empty-state">
            <mat-icon id="empty-state--icon">sensors</mat-icon>
            <p id="empty-state--title">
              {{ error()?.message ?? 'No fluorescence channels found' }}
            </p>
          </td>
        </tr>
      </table>
    </div>
  }
</div>
